import cloneArrayBuffer from "./_cloneArrayBuffer.js";
function cloneTypedArray(typedArray, isDeep) {
  var buffer = cloneArrayBuffer(typedArray.buffer);
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
export {
  cloneTypedArray as default
};
//# sourceMappingURL=_cloneTypedArray.js.map
